export enum TargetReasonEnum {
    ProductionMixChange = 4,
    WrongReporting = 5,
    LineModification = 6,
    UnforeseenEvent = 7,
    NewLegislation = 8,
    GroupDivisionalChange = 9,
    ProductionCurtailment = 10,
    InitialEntry = 11,
    TypoCorrection = 12
} 

export enum CategoriesEnum {
    Electricity = 'Electricity',
    Heat = 'Heat',
    Water = 'Water',
  }